export const footerInjectTargetSelector = false;
export const footerInjectInside = true;
export const footerComponentId = 'cc-footer';
export const noHTTPSWarningMessage = `<p>This app requires https. <a href="${window.location.toString().replace('http', 'https')}">Click here to switch</a></p>`;
export const GPSEnabled = true;
export const GPSTimeout = 15000;
export const GPSHighAccuracy = false;
export const GPSMaxAge = 1000 * 60 * 10; // 10mins
export const cacheLengthInSeconds = 60 * 60; // 60mins
export const paymentTypes = {
	payPal: true,
	applePay: false,
	googlePay: false
};

export const appPaymentId = 'Credit Card';
export const paypalPaymentId = 'PayPal';



// WEBPACK FOOTER //
// ./src/vue/settings.js